<template>
    <div class="modal" :id="identifier" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered" style="max-width: 900px;">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title text-center">
                        Address Lookup
                    </h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body bg-light">
                    <AdminBlock>
                        For an address to be selectable it must have valid latitude and longitude coordinates stored.
                    </AdminBlock>
                    <div class="block block-rounded mb-0">
                        <div class="block-content block-content-full">
                            <table ref="table" class="table table-bordered table-striped table-vcenter dataTable" style="width: 100%;">
                                <thead>
                                    <tr>
                                        <th>Address</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody @click="handleAddressEvent"></tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                        Close
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, watch, onMounted, nextTick } from 'vue';
import axios from 'axios';
import { errorAlert, successAlert } from '@/utils.js';
import AdminBlock from "@/components/movements/components/AdminBlock.vue";

const props = defineProps({
    forMap: String,
    customer: Object,
    identifier: {
        type: String,
        required: true
    }
});
const emit = defineEmits(['update:address']);

const internalCustomer = ref(props.customer);
const ajaxUrl = ref('');
const table = ref(null);

const generateAddressLookupRoute = () => {
    if (internalCustomer.value) {
        return route('api.movements.addresses.lookup', { customer: internalCustomer.value.id });
    }
    return route('api.movements.addresses.lookup');
}

const initialiseDatatable = () => {

    // This is a co-pilot special. Works fine though.
    if (window.jQuery(table.value).hasClass('dataTable')) {
        window.jQuery(table.value).DataTable().clear().destroy();
        window.jQuery(table.value).off('preXhr.dt');
    }

    window.jQuery(table.value).on('preXhr.dt', (e, settings, data) => {
        data.for_map = props.forMap;
    }).dataTable({
        processing: true,
        serverSide: true,
        deferRender: true,
        pageLength: 10,
        lengthMenu: [10, 25, 50, 100],
        ajax: {
            url: ajaxUrl.value
        },
        autoWidth: false,
        columnDefs: [
            { targets: 1, width: '200px' }
        ],
        columns: [
            { data: 'full_address', orderable: false, searchable: false },
            { data: 'computed_button', orderable: false, searchable: false }
        ]
    });
}

async function handleAddressEvent(e) {
    const target = e.target;
    if (target.tagName === 'BUTTON') {
        const id = target.dataset.id;
        const address = target.dataset.address;
        if (!id || !address) {
            errorAlert('Address is missing information needed to find it on a map', 'Address Error');
            return;
        }
        try {
            const response = await axios.get(route('api.movements.addresses.details', { id }));
            const details = response.data;
            if (!details.lat || !details.lng) {
                const customError = {
                    response: {
                        data: {
                            errors: {
                                address: ['Address does not have valid coordinates to display on a map.']
                            }
                        }
                    }
                };
                errorAlert(customError, 'Address Error');
                return;
            }
            emit('update:address', { id, address, ...details });
            successAlert('Address Updated', 'Success');
            window.jQuery('#' + props.identifier + ' .btn-close').click();
        } catch (errors) {
            errorAlert(errors, 'Error fetching address details');
        }
    }
}

watch(() => props.customer, (newVal) => {
    // Destroy the existing datatable if it exists
    internalCustomer.value = newVal;
});

watch(internalCustomer, () => {
    ajaxUrl.value = generateAddressLookupRoute();
    nextTick(() => {
        initialiseDatatable();
    });
});

onMounted(() => {
    ajaxUrl.value = generateAddressLookupRoute();
    initialiseDatatable();
});
</script>
